import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';

const { regenTokenandBrowse } = browseAPIhandler();
//get docs home details from the contents repo
const getDocsHomeDetails = (url, fileName) => {
  const docsHomeData = getFileContent(
    `${url}?resourcePath=pages/docs-home&resourceName=${fileName}`,
    regenTokenandBrowse,
  );
  return docsHomeData;
};

export { getDocsHomeDetails };
